class SubscriptionTitle implements ng.IComponentController {
    sbTitle: string;
}

angular.module('animatronApp.SubscriptionTitle', [])
    .component('subscriptionTitle', {
        bindings: {
            sbTitle: '<'
        },
        transclude: true,
        controller: SubscriptionTitle,
        templateUrl: require('settings/subscription/subscription-title.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionTitle.ts